import { render } from "./ShopCar.vue?vue&type=template&id=0aef5e5e&scoped=true"
import script from "./ShopCar.vue?vue&type=script&lang=js"
export * from "./ShopCar.vue?vue&type=script&lang=js"

import "./ShopCar.vue?vue&type=style&index=0&id=0aef5e5e&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aef5e5e"]])

export default __exports__